"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketReplicationOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketReplicationOutput.js.map